import controller from './wf-affect-list-history.controller';
import template from './wf-affect-list-history.html';

export default {
	controller,
	template,
	bindings: {
		disabled:        '<ngDisabled',
		options:         '<',
		selected:        '=',
		affectList:      '<?',
	},
	require: {
		wfAffectList: '^^?',
	}
};
